"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NegativeSpaceLens = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const LensTop_1 = require("./LensTop");
const LensLeft_1 = require("./LensLeft");
const LensRight_1 = require("./LensRight");
const LensBottom_1 = require("./LensBottom");
exports.NegativeSpaceLens = (0, react_1.forwardRef)((props, ref) => {
    const { cursorOffset, fadeDurationInMs, isActive, isPositionOutside, position, style: userSpecifiedStyle } = props, rest = __rest(props, ["cursorOffset", "fadeDurationInMs", "isActive", "isPositionOutside", "position", "style"]);
    const compositLensStyle = Object.assign({ backgroundColor: 'rgba(0,0,0,.4)' }, userSpecifiedStyle);
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({}, rest, { children: [(0, jsx_runtime_1.jsx)(LensTop_1.LensTop, Object.assign({}, props, { ref: ref, style: compositLensStyle })), (0, jsx_runtime_1.jsx)(LensLeft_1.LensLeft, Object.assign({}, props, { ref: ref, style: compositLensStyle })), (0, jsx_runtime_1.jsx)(LensRight_1.LensRight, Object.assign({}, props, { ref: ref, style: compositLensStyle })), (0, jsx_runtime_1.jsx)(LensBottom_1.LensBottom, Object.assign({}, props, { ref: ref, style: compositLensStyle }))] })));
});
exports.NegativeSpaceLens.displayName = 'NegativeSpaceLens';
//# sourceMappingURL=index.js.map